import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=4b06defa&scoped=true&"
import script from "./Progress.vue?vue&type=script&lang=js&"
export * from "./Progress.vue?vue&type=script&lang=js&"
import style0 from "./Progress.vue?vue&type=style&index=0&id=4b06defa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06defa",
  null
  
)

export default component.exports